
import Vue from 'vue'
import RContextMenu from '@/components/navigation/ContextMenu.vue'

const menuItems = [
  {
    text: 'Found a bug?',
    to: '/bug',
    dot: '#4b8fe2',
    hasDivider: true,
  },
  {
    text: 'Pricing',
    to: 'https://renderro.com/pricing/',
  },
  {
    text: 'Official website',
    to: 'https://renderro.com',
  },
  {
    text: 'Contact us',
    to: 'https://renderro.com/contact/',
  },
]

export default Vue.extend({
  name: 'HelpContextMenu',
  components: {
    RContextMenu,
  },
  computed: {
    items() {
      return menuItems
    },
  },
})
